import type { FC } from "react";
import { PostBroadcastProvider } from "../../../../components/posts/post-broadcast.context";
import { useBroadcastScore } from "../../../../hooks/use-broadcast-score";
import { usePosts } from "../../../../hooks/use-posts";
import type { Broadcast } from "../../../../types/broadcasts.types";
import { getPostItem } from "../../../broadcast-portal/modules/feed-module/feed-items/feed-items.factory";
import FeedVarReview from "../../../broadcast-portal/modules/feed-module/feed-var-review/feed-var-review";

type PostFeedProps = {
	broadcastId: string | null;
	broadcast: Broadcast | null;
};

const ViewerPostFeed: FC<PostFeedProps> = ({ broadcastId, broadcast }) => {
	const posts = usePosts(broadcastId);
	const { varReview } = useBroadcastScore(broadcastId);

	return (
		<PostBroadcastProvider
			value={{
				broadcastId,
				broadcastUserId: broadcast?.userId ?? null,
				fixtureId: broadcast?.fixtureId ?? null,
				homeTeam: broadcast?.homeTeam ?? "",
				awayTeam: broadcast?.awayTeam ?? "",
				homeLogo: broadcast?.homeLogo ?? "",
				awayLogo: broadcast?.awayLogo ?? "",
			}}
		>
			<div style={{ paddingBottom: "5rem" }}>
				{varReview && <FeedVarReview />}
				<div>{posts.map((post) => getPostItem(post))}</div>
			</div>
		</PostBroadcastProvider>
	);
};

export default ViewerPostFeed;
